<template>
	<div>
		<div v-if="transaksi.rincian_pembayaran.filter(a => a.jenis_bayar === 10).length === 0">
			<div class="d-flex-between-center p-d-8">
				<div class="f-regular f-16 f-c-midgrey">
					Konsumen
				</div>
				<div class="f-regular f-16 f-c-black">
					{{ transaksi.detail_transaksi.nama_konsumen }}
				</div>
			</div>
			<div class="d-flex-between-center p-d-8 border-bottom">
				<div class="f-regular f-16 f-c-midgrey">
					Nomor Telpon
				</div>
				<div class="f-regular f-16 f-c-black">
					{{ transaksi.detail_transaksi.telp_konsumen !== "" ? "+" + transaksi.detail_transaksi.telp_konsumen : "-" }}
				</div>
			</div>

			<div class="separator-line-dot p-d-8"></div>
		</div>

		<div v-if="transaksi.detail_transaksi.tanggal_transaksi === undefined">
			<div class="d-flex-between-center" v-if="transaksi.detail_transaksi.tanggal_selesai !== ''">
				<div class="f-regular f-16 f-c-midgrey">
					Diterima
				</div>
				<div class="f-regular f-16 f-c-black">
					{{ transaksi.detail_transaksi.tanggal_diterima }}
				</div>
			</div>
      <div class="d-flex-between-center p-t-8"
           v-if="transaksi.detail_transaksi.tanggal_selesai !== '' && !isSelfService && transaksi.detail_transaksi.status_selesai === 2">
        <div class="f-regular f-16 f-c-midgrey">
          Selesai
        </div>
        <div class="f-regular f-16 f-c-black">
          {{ transaksi.detail_transaksi.tanggal_selesai_pengerjaan }}
        </div>
      </div>
			<div class="d-flex-between-center p-t-8"
			     v-else-if="transaksi.detail_transaksi.tanggal_selesai !== '' && !isSelfService && transaksi.detail_transaksi.status_selesai !== 2">
				<div class="f-regular f-16 f-c-midgrey">
					Estimasi Selesai
				</div>
				<div class="f-regular f-16 f-c-black">
					{{ transaksi.detail_transaksi.tanggal_selesai }}
				</div>
			</div>
			<div class="d-flex-between-center p-d-8" v-if="transaksi.detail_transaksi.tanggal_selesai === ''">
				<div class="f-regular f-16 f-c-midgrey">
					Tgl Transaksi
				</div>
				<div class="f-regular f-16 f-c-black">
					{{ transaksi.detail_transaksi.tanggal_diterima }}
				</div>
			</div>
		</div>
		<div class="d-flex-between-center p-d-8" v-else>
			<div class="f-regular f-16 f-c-midgrey">
				Tgl Transaksi
			</div>
			<div class="f-regular f-16 f-c-black">
				{{ transaksi.detail_transaksi.tanggal_transaksi }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOTransaksiInfo",
	props: {
		transaksi: Object,
		isSelfService: Boolean,
	},
}
</script>